/* React */
import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'

import Loading from 'src/components/Loading/Loading'

/* Context */
import { useContext } from 'react'
import { AppContext } from 'src/AppContext'

/* Optionen */
import routes from './routeConfig'
import { isFeatureEnabled } from 'src/features'

const NotFound = lazy(()=>import('src/routes/NotFound/NotFound'))
const KeinRecht = lazy(()=>import('src/routes/KeinRecht/KeinRecht'))

export { preloadRoute as preload } from './preloadRoute'

const Router:React.FC = () => {
  const { haveRight } = useContext(AppContext)

  return <main className="App-main">

    <Routes>

      {Object.values(routes).map(({
        Component, paths, right, feature,
      }, index) => paths.map(path => (
        <Route 
          key={`${index}/${path}`}
          {...{path}}
          element={
            <Suspense fallback={<Loading fullScreen />}>
              {isFeatureEnabled(feature) && (!right || haveRight(right)) ? <Component /> : <KeinRecht />}
            </Suspense>
          }
        />

      )))}

      <Route
        path="*"
        element={
          <Suspense fallback={<Loading fullScreen />}> 
            <NotFound />
          </Suspense>
        }
      />

    </Routes>
    
  </main>
}

export default Router
